import { createI18n } from "vue-i18n"
import zhtw from "./element-plus/zh-tw"
import zhcn from "./element-plus/zh-cn"
import enus from "./element-plus/en"
import messages from "../../lang"

// 可用語系
export const EnableLang = {
  zh_TW: "zh-tw",
  zh_CN: "zh-cn",
  en_US: "en-us",
}

export const ElementPlusLocale = {
  [EnableLang.zh_TW]: zhtw,
  [EnableLang.zh_CN]: zhcn,
  [EnableLang.en_US]: enus,
}

export const languageOptions = {
  [EnableLang.zh_TW]: "繁體中文",
  [EnableLang.zh_CN]: "简体中文",
  [EnableLang.en_US]: "English",
}

const defaultLocale = Cookies.get()._LOCALE_ || EnableLang.zh_TW
export const elLang = ElementPlusLocale[defaultLocale]

// call with I18n option
export const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: EnableLang.zh_TW,
  globalInjection: true,
  legacy: false,
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
})
